export const ToWechat = (url: string) => {
  const { hostname } = window.location

  // 本地/内网开发环境：直接跳转到当前前端路由页，不走微信 OAuth
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.')) {
    window.location.hash = '#/' + url
    return
  }

  // 线上环境：走原来的微信 OAuth 流程
  const redirectUrl: any = encodeURIComponent('https://ywtb.xauat.edu.cn/vehicles/#/' + url)
  const appId = 'wx863372e4ff22d7c8'
  window.location.href =
    'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
    appId +
    '&redirect_uri=' +
    redirectUrl +
    '&response_type=code&scope=snsapi_base&state=123456'
}

export const GetQueryString = (name: string) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}
